var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.2632 11.3333V12.0556C13.2632 12.85 12.6 13.5 11.7895 13.5H1.47368C0.655789 13.5 0 12.85 0 12.0556V1.94444C0 1.15 0.655789 0.5 1.47368 0.5H11.7895C12.6 0.5 13.2632 1.15 13.2632 1.94444V2.66667H6.63158C5.81368 2.66667 5.15789 3.31667 5.15789 4.11111V9.88889C5.15789 10.6833 5.81368 11.3333 6.63158 11.3333H13.2632ZM6.63158 9.88889H14V4.11111H6.63158V9.88889ZM9.57895 8.08333C8.96737 8.08333 8.47368 7.59944 8.47368 7C8.47368 6.40056 8.96737 5.91667 9.57895 5.91667C10.1905 5.91667 10.6842 6.40056 10.6842 7C10.6842 7.59944 10.1905 8.08333 9.57895 8.08333Z",
  fill: "white"
});

function SvgWalletIconWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIconWhite);
export default __webpack_public_path__ + "static/media/wallet_icon_white.414e4e8e870d927c1b36074ccb3a8336.svg";
export { ForwardRef as ReactComponent };